import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../plugins/feathersClient';

class Student extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Student';

  // Define default properties here
  static instanceDefaults() {
    return {
      dateOfBirth: null,
      citizenship: null,
      married: null,
      countryId: null,
      city: null,
      phone: null,
      initialLanguageLevel: null,
      timezoneOffset: null
    };
  }
}
const servicePath = 'students';
const servicePlugin = makeServicePlugin({
  Model: Student,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
